<p-multiselect
  class="cx-multi-select__control"
  [inputId]="inputId"
  [options]="options"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [group]="group"
  [optionGroupLabel]="optionGroupLabel ?? ''"
  [optionGroupChildren]="optionGroupChildren ?? ''"
  [appendTo]="appendTo"
  panelStyleClass="cx-multi-select-panel"
  [placeholder]="placeholder"
  [selectedItemsLabel]="selectedItemsLabel"
  [disabled]="isDisabled"
  [loading]="loading"
  [filter]="filter"
  [showHeader]="showPanelHeader"
  [showClear]="showClear"
  [invalid]="isInvalid"
  [dataKey]="optionValue"
  [ngModel]="multiValue"
  [ngModelOptions]="{ standalone: true }"
  (ngModelChange)="onSelectionChange($event)"
  (onBlur)="onBlur()">
  @if (headerTemplate) {
    <ng-template pTemplate="header">
      <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
    </ng-template>
  }
  @if (itemTemplate) {
    <ng-template pTemplate="item" let-option>
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: option }"></ng-container>
    </ng-template>
  }
</p-multiselect>
